import { render } from "./CIS-Accordion.vue?vue&type=template&id=a557c14a"
import script from "./CIS-Accordion.vue?vue&type=script&lang=js"
export * from "./CIS-Accordion.vue?vue&type=script&lang=js"

import "./CIS-Accordion.vue?vue&type=style&index=0&id=a557c14a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__